import { BaseDataModel } from "./base";

export class Grower extends BaseDataModel {
	name!: string;
	companyIds!: string[];
	phoneNumber?: string;
	unreadyJobCount?: number; // formula
	companiesFromJobs?: string[]; // rollup

	// used for creating new growers from 3rd party integrations
	externalId?: string;
}
